<template>
    <div class="container-success">
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Inter&display=swap" rel="stylesheet">
        <div class="container-local">
            <div class="main-content">
                <div class="gif">
                    <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_42mtixws.json"  background="transparent"  speed="1"  style="width: 120px; height: 120px;"  loop autoplay></lottie-player>
                </div>
                <p class="text">Account added</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Success',
    components: {
    },
    data: () => ({
    }),
    methods: {
    }
}
</script>
<style lang="scss" scoped>
@import "@/components/dashboard/dashboard.scss";
.container {
    height: 100% !important;
    align-items : center;
    margin:0px;
}
.text {
    font-family: Inter;
    font-size: 21px;
    font-weight: 500;
    line-height: 25px;
    letter-spacing: 0em;
    text-align: center;
    color: #232323;
    margin-top: 14px
}
container-local {
    height: 100%;
}
.container-success {
    height: 100%;
    display: flex;
}
.gif {
    justify-content: center !important;
    display: flex;
    width: 122px;
    height: 122px;
    align-items :center;
    border-radius: 8px;
}
img {
    width: 122px;
    height: 122px;
}
.main-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
}
@media (max-width: 480px) {
    .text {
        font-size: 17px;
    }
}
</style>
